export const STATE_IDS = {
  ASSESSMENT_REVIEW: 'ASSESSMENT_REVIEW',
  VISUAL: 'VISUAL',
  NO_VISUAL: 'NO_VISUAL',
  MALADAPTIVE: 'MALADAPTIVE',
  ASSESSMENT_METHOD: 'ASSESSMENT_METHOD',
  ASSESMENT_SUMMARY: 'ASSESSMENT_SUMMARY',
  ASSESSMENT_BARRIER: 'ASSESSMENT_BARRIER',
  NO_ASSESSMENT_TOOL: 'NO_ASSESSMENT_TOOL',
} as const;

export const PERSIST_DATA_STATES = {
  [STATE_IDS.ASSESSMENT_REVIEW]: 'assessmentReview',
  [STATE_IDS.VISUAL]: 'visual',
  [STATE_IDS.MALADAPTIVE]: 'maladaptive',
  [STATE_IDS.ASSESSMENT_METHOD]: 'assessmentMethod',
  [STATE_IDS.ASSESMENT_SUMMARY]: 'assessmentSummary',
  [STATE_IDS.ASSESSMENT_BARRIER]: 'assessmentBarrier',
  [STATE_IDS.NO_ASSESSMENT_TOOL]: 'noAssessmentTool',
} as const;

export const ERROR_STATES = {
  ...PERSIST_DATA_STATES,
  [STATE_IDS.NO_VISUAL]: 'noVisual',
} as const;
